/**
 * Folder / section IDs stored on subjectPublicationClaims.sectionIds must be UUID strings only.
 * Postgres jsonb arrays may historically contain null or invalid entries; strip those before writes or typed GraphQL variables.
 */
const SECTION_FOLDER_UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function sanitizeSectionIdsForClaims(ids: readonly (string | null | undefined)[]): string[] {
  return [
    ...new Set(
      ids.filter(
        (id): id is string => typeof id === 'string' && SECTION_FOLDER_UUID_RE.test(id)
      )
    )
  ];
}
